/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateCurrentPage } from 'state/slices/app'
// material
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { Button, InlineMessage } from '@insticator/insticator-ui'
import { url } from 'utils/urls'
import PreviewConfig from '../../previewconfig/previewconfig'
import Space from 'material/space/space'
import { ReactComponent as WarningIcon } from 'assets/icons/error-circle.svg'
// styles
import injectSheet from 'react-jss'
import styles from './loginauthentication_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : LOGIN AUTHENTICATION ~~~~~~~~~~ ========== */
const LoginAuthentication = injectSheet(styles)((props) => {
  const dispatch = useDispatch()

  const mocked = useSelector(state => state.session.mocked);

  return (
    <SectionGroupV2 
      klass={`loginauthentication ${props.classes.loginauthentication}`}
      title={'User Authentication'} 
      description={`
        Manage how your end-users signup/login to the commenting unit.
      `}
      indented
    >
      <div className='explainer'>
        <ul>
          <li>We offer a variety of login capabilities to end-users for a frictionless authentication experience. You have total control over which options are available to users.</li>
          <li>Users can create a custom account via email address of their choosing.</li>
          <li>Users can sign in via Social <acronym title="Single Sign-On">SSO</acronym> options like Google, Facebook/META and Twitter/X.</li>
          <li>Using a <a href="https://documentation.insticator.com/docs/implement-single-sign-on" target="_blank"><strong>Custom SSO integration</strong></a>, commenters can use the account they've created for your site to access the commenting unit.</li>
        </ul>
        { mocked ?
          <Button
            klass={'configbutton'}
            variant={'neutral'}
            text={'Configure'}
            handleClick={() =>  dispatch(updateCurrentPage('/dashboard/settings/company?view=authenticationConfig')) }
          />
          :
            <InlineMessage 
              key={'meow'}
              display={true}
              name={'publishermessage'}
              variant={'neutral'}
              icon={''}
              message={
              <Space alignItems={'center'}>
                <WarningIcon className='warningicon' /> Contact your Account Manager
              </Space>
              }
              close={false}
            />
        }
      </div>
      <PreviewConfig>
        <img src={`${url.image}/2.0/auth-preview.png`}  width={250} height={254} />
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default LoginAuthentication;